export const handleChange = (
    event,
    setRequiredInput,
    setErrorMessage,
    newInput,
    setNewInput
) => {
    let value = event.target.value;
    let checked = event.target.checked;
    if (event.target.name === "required") {
        if (checked) {
            value = 1;
            setRequiredInput(value);
        } else {
            value = 0;
            setRequiredInput(value);
        }
    }

    if (event.target.name === "error") {
        if (checked) {
            value = 1;
            setErrorMessage(value);
        } else {
            value = 0;
            setErrorMessage(value);
        }
    }

    if (event.target.name === "reply_to") {
        if (checked) {
            value = 1;
        } else {
            value = 0;
        }
    }

    setNewInput({
        ...newInput,
        [event.target.name]: value,
    });
};

export default handleChange;
